import omit from 'lodash/omit';

export default (props: object): object =>
  omit(props, [
    'addLabel',
    'allowEmpty',
    'basePath',
    'cellClassName',
    'className',
    'formClassName',
    'headerClassName',
    'label',
    'linkType',
    'link',
    'locale',
    'record',
    'refetch',
    'resource',
    'sortable',
    'sortBy',
    'source',
    'textAlign',
    'translateChoice'
  ]);
